const ITEMS = [
  "KAMI HADIR DI:",
  "KUBU RAYA",
  "LANDAK",
  "BENGKAYANG",
  "SANGGAU",
  "SEKADAU",
  "MELAWI",
  "SINTANG",
  "PUTUSSIBAU",
  "KETAPANG",
  "KAYONG UTARA",
  "INTERNET UNTUK SEMUA",
];

export default function Marquee() {
  return (
    <div
      data-testid="marquee"
      className="relative overflow-hidden border-y border-white/10 bg-[#0A1124]/60 py-5"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex shrink-0 items-center" aria-hidden={dup === 1}>
            {ITEMS.map((item) => (
              <span
                key={`${dup}-${item}`}
                className="flex items-center gap-6 px-6 font-display text-lg font-bold tracking-wide text-slate-500 sm:text-xl"
              >
                {item}
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
